import { differenceInSeconds } from 'date-fns'
import formatDuration from 'app/functions/formatDuration'
import Clock from 'app/components/Clock'

export default ({ startedAt, size = 'big', onTick, timeout }) => {
  const [currentDisplay, setCurrentDisplay] = useState('00:00')
  const [seconds, setSeconds] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => {
      let newSeconds = differenceInSeconds(new Date(), startedAt)

      if (!isNaN(timeout)) newSeconds = timeout - newSeconds

      const formatted = formatDuration(newSeconds)

      if (onTick) {
        onTick({ newSeconds, formatted })
      }

      setCurrentDisplay(formatted)
      setSeconds(newSeconds)
    }, 1000)

    return () => {
      clearInterval(interval)
    }
  }, [startedAt])

  return <Clock size={size} seconds={seconds} currentDisplay={currentDisplay} />
}
